<app-form (submit)="submit()">
  <div class="layout">
    @if (submitting) {
      <div style="text-align:center;">
        Changing your email address...
        <app-spinner></app-spinner>
      </div>
    }
    @if (!submitting) {
      @if (emailError) {
        <div class="alert alert-danger">
          {{emailError}}
        </div>
      }
      <div>
        <label class="key">Current Email:</label>
        {{user?.email}}
      </div>
      <mat-form-field appearance="outline">
        <mat-label>New Email</mat-label>
        <input matInput type="email" name="email" [(ngModel)]="newEmail" autocomplete="email" pattern=".*@.*" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Confirm Email</mat-label>
        <input matInput type="email" name="email2" [(ngModel)]="newEmail2" autocomplete="email" pattern=".*@.*" />
      </mat-form-field>
      <div class="actions">
        <button mat-raised-button color="primary">
          <mat-icon>check</mat-icon>
          Save
        </button>
        <a mat-button (click)="canceled.next()">Cancel</a>
      </div>
    }
  </div>
</app-form>